





















































import { defineComponent, PropType } from '@vue/composition-api';

import AtomButton from '@/components/atoms/AtomButton.vue';
import AtomDivider from '@/components/atoms/AtomDivider.vue';
import AtomTypography from '@/components/atoms/AtomTypography.vue';
import WrapperCard from '@/components/atoms/WrapperCard.vue';

export default defineComponent({
  name: 'AdvisorSearchSideMenu',
  components: {
    AtomButton,
    AtomDivider,
    AtomTypography,
    WrapperCard,
  },
  props: {
    userId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    isRequester: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    return {};
  },
});
